<template> 
    <Navbar></Navbar>

    <br/>    
    <h3 style="margin-left: 10px">Vistorias por período</h3>

    <br/>
    <div class="container area" style="margin-left: 10px">
        <div class="">
            <label>De</label>
            <input type="Date" class="form-control" v-model="dataInicio" max="9999-12-31" @keyup.enter="filtrarPorPeriodo()">
        </div>

        <div class="">
            <label>Até</label>
            <input type="date" class="form-control" v-model="dataFim" max="9999-12-31" @keyup.enter="filtrarPorPeriodo()">
        </div>
        <div class="">
            <br/>
            <button class="btn btn-primary" v-on:click="filtrarPorPeriodo()"> Localizar por período</button>
        </div>
    </div>
            

    <br/>

    <div v-if="isTabelaOk">
        <Table :vistorias="vistorias" :email="email"></Table>
        <p v-if="this.vistorias != null" style="margin-left: 10px"><strong>{{numVistorias}}</strong> vistoria(s) encontrada(s)</p>
        <router-link to='/Home' style="margin-left: 10px;" title='Voltar para o início'>
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
            </svg>
        </router-link>
    </div>
    
    
</template>


<script>

import APIv3 from '../services/apiv3-endpoints'
import Table from '../components/Table.vue'
import Navbar from '../components/Navbar.vue'



const token = localStorage.getItem('token')
const vistoriador = localStorage.getItem('idUsuario')

const msgDataVazia = "Nenhuma vistoria encontrada: Campo de data vazio."
const msgSemResultados = "Não foram encontrados resultados para o período especificado."
const msgInvalidDataRange = "Período inválido: A data de início fornecida é maior que a de término."

const emptyDateField = (dataInicio, dataFim) => { if(dataInicio == '' || dataFim == ''){return true} else{return false}}

export default {
    name: 'LocalizaPeriodo',
    components: {
        Table,
        Navbar
    },

    data(){
        return{
            dataInicio: "",
            dataFim: "",
            vistorias: null,
            email: localStorage.getItem('email'),
            numVistorias: 0,
            showMsgDataVazia: false,
            showMsgInvalidRange: false,
            showMsgSemResultados: false,
            isTabelaOk: false
        }
    },

    methods: {
        filtrarPorPeriodo(){
            this.vistorias = null
            if(emptyDateField(this.dataInicio, this.dataFim)){
                this.showMsgDataVazia = true
                this.showValidationAlert(msgDataVazia)
                return
            }

            
            if(Date.parse(this.dataInicio) > Date.parse(this.dataFim)){
                this.showMsgInvalidRange = true
                this.showValidationAlert(msgInvalidDataRange)
                return
            }

            
            APIv3.localizarPorPeriodo(token, vistoriador, this.dataInicio, this.dataFim)
                .then(response =>{
                    this.vistorias = response.data
                    if(this.vistorias.length == 0){
                        this.showMsgSemResultados = true
                        this.showValidationAlert(msgSemResultados)
                    }
                    else{
                        this.numVistorias = this.vistorias.length
                        this.isTabelaOk = true
                        this.showAlert()
                    }
                })
                .catch(err => {    
                    console.log(err)
                    this.showErrorMessage()
                })    
        },

        showAlert(){
            this.$swal("Atenção!",'Serão encontradas somente as últimas 100 vistorias do período.','info')
        },

        showValidationAlert(msg){
            this.$swal(msg)
        },

        showErrorMessage(){
            this.$swal('Erro!','Falha ao realizar a busca por vistorias.', 'error')
        }
    }
    
}


</script>

<style>
    .content-area{
        margin-top: 100px;
        margin-bottom: 100px;
    }

    .area{
        max-width: 300px;
    }

</style>